import { useAuth } from '@/auth/AuthContext'
import { requireAuth } from '@/auth/requireAuth'
import { Card, CardContent } from '@/components/ui/card'
import { PageTitle } from '@/layout/page-title'
import { getRoles } from '@/people'
import { createFileRoute, useLoaderData } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/_layout/profile')({
  component: RouteComponent,
  loader: async () => {
    const { data, error } = await getRoles();
    return { roles: data, errorRoles: error }
  },
  beforeLoad: async () => await requireAuth(),
})

function RouteComponent() {
  const auth = useAuth()
  const { roles, errorRoles: _ } = useLoaderData({ from: '/(app)/_layout/profile' });
  return (
    <div className="container max-w-[1900px] py-10 px-4">
      <div className="space-y-4">
        <PageTitle title="Profile" />
        <div className="flex flex-col gap-4">
          <Card>
            <CardContent>
              <p><strong>Email:</strong> {auth?.user?.profile?.preferred_username}</p>
              <p><strong>Username:</strong> {auth?.user?.profile.name}</p>
            </CardContent>
          </Card>
          <Card >
            <CardContent>

              <p><strong>Roles:</strong></p>
              <ul>
                <li>Operator: {roles?.isOperator == true ? 'yes' : 'no'}</li>
                <li>Pm: {roles?.isPm ? 'yes' : 'no'}</li>
                <li>CLevel: {roles?.isClevel ? 'yes' : 'no'}</li>
              </ul>
            </CardContent>
          </Card>
        </div>
        {/* <div >
          {
            JSON.stringify(auth?.user, null, 2)
          }
        </div>  */}

      </div>
    </div>
  )
}
